import { type Ref, computed, ref } from 'vue';

type UseStickyNameCellOptions = {
  hasChanges: Ref<boolean>;
};

export default function useStickyNameCell({
  hasChanges,
}: UseStickyNameCellOptions) {
  const isHovered = ref(false);

  // Return the style object directly, eliminating the middleman
  const nameCellStyle = computed(() => {
    if (isHovered.value && hasChanges.value)
      return { backgroundColor: 'rgb(236, 239, 251)' };
    if (isHovered.value) return { backgroundColor: '#f1f5f9' };
    if (hasChanges.value) return { backgroundColor: 'rgb(247, 247, 255)' };
    return { backgroundColor: 'white' };
  });

  return {
    isHovered,
    nameCellStyle,
  };
}
